import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import ModalPopup from '@ui/components/VnModal';
import VnButton from '@ui/components/VnButton';
import { addOutline, closeCircleOutline, pencilOutline, saveOutline, timeOutline } from 'ionicons/icons';
import CalculationTable from './CalculationTable';
import AddCalculationForm from './AddCalculationForm';
import { deleteCalculationByIdAsync, getAllCalculationsByWorkOrderIDAsync, updateBulkCalcualtionAsync } from '@application/features/calculations/CalculationThunk';
import { useParams } from 'react-router-dom';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import VnConfirmationModel from '@ui/components/VnConfirmationModel';
import { handleRolePermission } from '@infrastructure/helpers';
import { VisserModule } from '@application/common/enums/visser-module';
import { updateModulePermissionsStatusAsync } from '@application/features/workorders/workorderThunk';
import { resetTimer, setModuleLock, unsetModuleLock } from '@application/features/workorders/workorderSlice';
import AddCalculationHoursForm from './AddCalculationHoursForm';
const CalculationTab = ({ formData, errors, onFieldChange, onToggelButtonChange, onCalendarChange, disableWorkOrder, isCalculationTabBold }) => {
    // const warningMessageRef = useRef<{ resetTimer: () => void } | null>(null);
    const dispatch = useAppDispatch();
    const { id } = useParams();
    const [calculationsList, setCalculationsList] = useState([]);
    const [calculationId, setCalculationId] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    const [totalQuantity, setTotalQuantity] = useState(0);
    const [inkoop, setInkoop] = useState(0);
    const [verkoop, setVerkoop] = useState(0);
    const [resultaat, setResultaat] = useState(0);
    const [groupNames, setGroupNames] = useState([]);
    const [totalQuantities, setTotalQuantities] = useState([]);
    const [totalInkoops, setTotalInkoops] = useState([]);
    const [totalVerkoops, setTotalVerkoops] = useState([]);
    const [resultaats, setResultaats] = useState([]);
    //-------------------
    const [isEditing, setIsEditing] = useState(false);
    const [editedData, setEditedData] = useState(null);
    const { calculations } = useAppSelector((state) => state.calculation);
    const [isDeleteCalculationConfirmOpen, setIsDeleteCalculationConfirmOpen] = useState(false);
    const [currentCalculationId, setCurrentCalculationId] = useState(null);
    //------------------
    const [isPersistantInfoCustomToasterOpen, setIsPersistantInfoCustomToasterOpen] = useState(false);
    const [isOpenHoursForm, setIsOpenHoursForm] = useState(false);
    const [hoursId, setHoursId] = useState(0);
    useEffect(() => {
        if (id) {
            dispatch(getAllCalculationsByWorkOrderIDAsync(parseInt(id)))
                .unwrap()
                .then((res) => {
                setCalculationsList(res);
                materialCalculations(res);
                if (isCalculationTabBold && res.length > 0) {
                    isCalculationTabBold(true);
                }
                else {
                    isCalculationTabBold && isCalculationTabBold(false);
                }
            });
        }
    }, [dispatch, id]);
    const onCalculationCloseClicked = () => {
        if (id)
            dispatch(getAllCalculationsByWorkOrderIDAsync(parseInt(id)))
                .unwrap()
                .then((res) => {
                setCalculationsList(res);
                materialCalculations(res);
                if (isCalculationTabBold && res.length > 0) {
                    isCalculationTabBold(true);
                }
                else {
                    isCalculationTabBold && isCalculationTabBold(false);
                }
            });
        setIsOpen(false);
    };
    const onCalculationRowClick = async (rowId) => {
        var moduleLockStatus = await checkModulelock();
        if (moduleLockStatus == false) {
            setCalculationId(rowId);
            setIsOpen(true);
        }
    };
    const onAddCalculationClick = async () => {
        var moduleLockStatus = await checkModulelock();
        if (moduleLockStatus == false) {
            setIsOpen(true);
            setCalculationId(0);
        }
    };
    function materialCalculations(listOfHoursAndMaterials) {
        const totalVerkoop = listOfHoursAndMaterials.reduce((sum, material) => {
            const price = material.sellingPrice ?? 0;
            const qty = material.quantity ?? 0;
            return sum + price * qty;
        }, 0);
        const totalNetPrice = listOfHoursAndMaterials.reduce((sum, material) => {
            const price = material.netPrice ?? 0;
            const qty = material.quantity ?? 0;
            return sum + price * qty;
        }, 0);
        setTotalQuantity(listOfHoursAndMaterials.filter((x) => x.unit === 'Uren').reduce((sum, material) => sum + (material.quantity || 0), 0));
        setInkoop(totalNetPrice);
        setVerkoop(totalVerkoop);
        setResultaat(totalVerkoop - totalNetPrice);
        //--------------------
        const groupedMaterials = listOfHoursAndMaterials.reduce((grouped, material) => {
            const groupName = material.group || 'overig';
            grouped[groupName] = grouped[groupName] || [];
            grouped[groupName].push(material);
            return grouped;
        }, {});
        const groups = Object.entries(groupedMaterials);
        //--------------------
        const cal_groupNames = [];
        const cal_totalNetPrices = [];
        const cal_totalQuantities = [];
        const cal_totalInkoops = [];
        const cal_totalVerkoops = [];
        const cal_resultaats = [];
        groups.forEach(([groupName, materials]) => {
            cal_groupNames.push(groupName);
            const groupNetPrice = materials.reduce((sum, material) => {
                const price = material.netPrice ?? 0;
                const qty = material.quantity ?? 0;
                return sum + price * qty;
            }, 0);
            const groupQuantity = materials.filter((x) => x.unit === 'Uren').reduce((sum, material) => sum + (material.quantity || 0), 0);
            cal_totalNetPrices.push(groupNetPrice);
            cal_totalQuantities.push(groupQuantity);
            const groupInkoop = materials.reduce((sum, material) => {
                const price = material.netPrice ?? 0;
                const qty = material.quantity ?? 0;
                return sum + price * qty;
            }, 0);
            const groupVerkoop = materials.reduce((sum, material) => {
                const price = material.sellingPrice ?? 0;
                const qty = material.quantity ?? 0;
                return sum + price * qty;
            }, 0);
            cal_totalInkoops.push(groupInkoop);
            cal_totalVerkoops.push(groupVerkoop);
            const resultaat = groupVerkoop - groupInkoop;
            cal_resultaats.push(resultaat);
        });
        setGroupNames(cal_groupNames);
        setTotalQuantities(cal_totalQuantities);
        setTotalInkoops(cal_totalInkoops);
        setTotalVerkoops(cal_totalVerkoops);
        setResultaats(cal_resultaats);
    }
    /*Start of region Calculation Tab */
    useEffect(() => {
        appendDataintoEdit();
    }, [calculations]);
    async function onEdit() {
        var moduleLockStatus = await checkModulelock();
        if (moduleLockStatus == false) {
            setIsEditing(true);
        }
    }
    function onSave() {
        if (editedData) {
            for (let i = 0; i < editedData.length; i++) {
                const item = editedData[i];
                if (item.quantity == '') {
                    item.quantity = 0;
                }
                if (item.grossPrice == '') {
                    item.grossPrice = 0;
                }
                if (item.discount == '') {
                    item.discount = 0;
                }
                if (item.netPrice == '') {
                    item.netPrice = 0;
                }
                if (item.sellingPrice == '') {
                    item.sellingPrice = 0;
                }
            }
            const poppedRow = editedData.pop();
            dispatch(updateBulkCalcualtionAsync(editedData)).then(() => {
                setIsEditing(false);
                dispatch(getAllCalculationsByWorkOrderIDAsync(parseInt(id)))
                    .unwrap()
                    .then((res) => {
                    setCalculationsList(res);
                    materialCalculations(res);
                });
            }).catch((error) => {
                if (poppedRow) {
                    const updatedData = [...editedData, poppedRow];
                    setEditedData(updatedData);
                }
            });
        }
    }
    function onCancel() {
        setIsEditing(false);
        appendDataintoEdit();
    }
    function appendDataintoEdit() {
        if (calculations) {
            setEditedData((data) => {
                const updatedData = calculations.map((calculation) => ({ ...calculation }));
                return updatedData;
            });
        }
    }
    function onEditData(data) {
        setEditedData(data);
    }
    const onAddArticleRowClick = () => {
        if (id)
            dispatch(getAllCalculationsByWorkOrderIDAsync(parseInt(id)))
                .unwrap()
                .then((res) => {
                setCalculationsList(res);
                materialCalculations(res);
                if (isCalculationTabBold && res.length > 0) {
                    isCalculationTabBold(true);
                }
                else {
                    isCalculationTabBold && isCalculationTabBold(false);
                }
            });
    };
    async function onDeleteCalculation(id) {
        var moduleLockStatus = await checkModulelock();
        if (moduleLockStatus == false) {
            setIsDeleteCalculationConfirmOpen(true);
            setCurrentCalculationId(id);
        }
    }
    function onDeleteCalculationClicked() {
        if (currentCalculationId) {
            dispatch(deleteCalculationByIdAsync(currentCalculationId))
                .unwrap()
                .then(() => {
                dispatch(getAllCalculationsByWorkOrderIDAsync(parseInt(id)))
                    .unwrap()
                    .then((res) => {
                    setCalculationsList(res);
                    materialCalculations(res);
                    if (isCalculationTabBold && res.length > 0) {
                        isCalculationTabBold(true);
                    }
                    else {
                        isCalculationTabBold && isCalculationTabBold(false);
                    }
                });
                setIsDeleteCalculationConfirmOpen(false);
            });
        }
    }
    //-------------------Module Lock Functionality---------------------------
    const checkModulelock = async () => {
        // if (warningMessageRef.current) {
        //     warningMessageRef.current.resetTimer();
        // }
        if (formData.id) {
            dispatch(resetTimer());
            var moduleLockRequestData = {
                moduleId: VisserModule.Werkorder,
                recordId: formData.id
            };
            try {
                const res = await dispatch(updateModulePermissionsStatusAsync(moduleLockRequestData)).unwrap();
                if (res.isModuleAlreadyLocked) {
                    // setIsPersistantInfoCustomToasterOpen(true);
                    dispatch(setModuleLock());
                    return true;
                }
                // setIsPersistantInfoCustomToasterOpen(false);
                dispatch(unsetModuleLock());
                return false;
            }
            catch (error) {
                // setIsPersistantInfoCustomToasterOpen(false);
                dispatch(unsetModuleLock());
                return false;
            }
        }
        return false;
    };
    //-------------------Hours Functionality --------------------
    const onAddHoursClick = async () => {
        var moduleLockStatus = await checkModulelock();
        if (moduleLockStatus == false) {
            setIsOpenHoursForm(true);
            setHoursId(0);
        }
    };
    function onHoursCloseClicked() {
        if (id)
            dispatch(getAllCalculationsByWorkOrderIDAsync(parseInt(id)))
                .unwrap()
                .then((res) => {
                setCalculationsList(res);
                if (isCalculationTabBold && res.length > 0) {
                    isCalculationTabBold(true);
                }
                else {
                    isCalculationTabBold && isCalculationTabBold(false);
                }
            });
        setIsOpenHoursForm(false);
    }
    const onCalculationHourRowClick = async (rowId) => {
        var moduleLockStatus = await checkModulelock();
        if (moduleLockStatus == false) {
            setHoursId(rowId);
            setIsOpenHoursForm(true);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: 'vn-Material-Add-buttons', children: [isEditing && (_jsxs(_Fragment, { children: [_jsx(VnButton, { icon: closeCircleOutline, customClassName: 'vn-action-button vn-inline-editing-action-button', mode: 'danger', size: 'sm', isDisabled: id && !disableWorkOrder ? false : true, customIconClassName: 'vn-action-button-icon vn-inline-editing-action-button-icon', onClick: () => {
                                    onCancel();
                                }, style: { marginTop: '0px' } }), _jsx(VnButton, { icon: saveOutline, customClassName: 'vn-action-button vn-inline-editing-action-button mr-14', mode: 'primary', size: 'sm', onClick: () => {
                                    onSave();
                                }, type: 'submit', customIconClassName: 'vn-action-button-icon vn-inline-editing-action-button-icon', style: { marginTop: '0px' }, isDisabled: !disableWorkOrder ? false : true })] })), !isEditing && (_jsx(VnButton, { icon: pencilOutline, customClassName: 'vn-action-button-cancel vn-inline-editing-action-button mr-14', mode: 'secondary', size: 'sm', customIconClassName: 'vn-action-button-cancel-icon vn-inline-editing-action-button-icon', onClick: () => {
                            onEdit();
                        }, style: { marginTop: '0px' }, isDisabled: handleRolePermission(Permission.CALCULATIE, PermissionType.Update) && !disableWorkOrder ? false : true })), _jsx(VnButton, { type: 'button', mode: 'primary', size: 'sm', customClassName: 'vn-add-button', icon: addOutline, onClick: onAddCalculationClick, style: { marginRight: '5px' }, isDisabled: handleRolePermission(Permission.CALCULATIE, PermissionType.Create) && !disableWorkOrder ? false : true, children: "Toevoegen Calculatie" }), _jsx(VnButton, { type: 'button', mode: 'primary', size: 'sm', customClassName: 'vn-add-button', icon: timeOutline, onClick: onAddHoursClick, style: { marginRight: '5px' }, isDisabled: handleRolePermission(Permission.CALCULATIE, PermissionType.Create) && !disableWorkOrder ? false : true, children: "Uren boeken" })] }), _jsxs("div", { className: 'vn-workorder-Container', children: [_jsx(CalculationTable, { isEditing: isEditing, editedData: editedData, editData: onEditData, onRowClick: onCalculationRowClick, onCalculationHourRowClick: onCalculationHourRowClick, deleteCalculation: onDeleteCalculation, disableWorkOrder: disableWorkOrder, formData: formData }), _jsxs("div", { className: 'vn-Material-CalculationCard', style: { fontSize: 'small' }, children: [_jsx("div", { style: { paddingTop: '6px', paddingLeft: '24px', paddingBottom: '0px' }, children: _jsx("label", { className: 'vn-Calculation-label', children: "Totale berekening" }) }), _jsxs("div", { className: 'row mb-0 vn-Calculation-Row', children: [_jsx("div", { className: 'col-md-2 vn-calculation-label-List', children: _jsxs("ul", { className: 'list-group list-group-flush', children: [_jsx("li", { className: 'list-group-item', children: "Groep:" }), _jsx("li", { className: 'list-group-item', children: "Uren:" }), _jsx("li", { className: 'list-group-item', children: "Inkoop(\u20AC):" }), _jsx("li", { className: 'list-group-item fw-bold', children: "Verkoop(\u20AC):" }), _jsx("li", { className: 'list-group-item', children: "Resultaat(\u20AC):" })] }) }), _jsx("div", { className: 'col-md-7', children: _jsxs("div", { className: 'row', children: [_jsxs("div", { className: 'col-md-2 vn-Calculation-Group', children: [_jsx("li", { className: 'list-group-item vn-Group-Text', children: "Totaal" }), _jsx("li", { className: 'list-group-item vn-Group-Text', children: Number(totalQuantity).toLocaleString('de-DE', {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            }) }), _jsx("li", { className: 'list-group-item vn-Group-Text', children: Number(inkoop).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }), _jsx("li", { className: 'list-group-item vn-Group-Text', children: Number(verkoop).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }), _jsx("li", { className: 'list-group-item vn-Group-Text', children: Number(resultaat).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) })] }), groupNames.map((groupName, index) => (
                                                // <div key={index} className='col-md-3  mt-1 vn-Calculation-Group'>
                                                _jsx("div", { className: 'col-md-3 vn-Calculation-Group', children: _jsxs("ul", { className: 'list-group list-group-flush', children: [_jsx("li", { className: 'list-group-item vn-Group-Text', children: groupNames[index] }), _jsx("li", { className: 'list-group-item vn-Group-Text', children: Number(totalQuantities[index]).toLocaleString('de-DE', {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                }) }), _jsx("li", { className: 'list-group-item vn-Group-Text', children: Number(totalInkoops[index]).toLocaleString('de-DE', {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                }) }), _jsx("li", { className: 'list-group-item vn-Group-Text', children: Number(totalVerkoops[index]).toLocaleString('de-DE', {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                }) }), _jsx("li", { className: 'list-group-item vn-Group-Text', children: Number(resultaats[index]).toLocaleString('de-DE', {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                }) })] }) }, index)))] }) })] })] })] }), _jsx(ModalPopup, { title: 'Toevoegen Calculatie', content: _jsx(AddCalculationForm, { onClose: () => onCalculationCloseClicked(), calculationId: calculationId, disableWorkOrder: disableWorkOrder, onAddArticleRowClick: onAddArticleRowClick }), onOpen: isOpen, onClose: () => onCalculationCloseClicked(), modalWidth: 'lg' }), _jsx(ModalPopup, { title: 'Uren boeken', content: _jsx(AddCalculationHoursForm, { onClose: () => onHoursCloseClicked(), hoursId: hoursId, workOrderNumber: formData.workOrderNumber, workOrderDescription: formData.description, disableWorkOrder: disableWorkOrder }), onOpen: isOpenHoursForm, onClose: () => onHoursCloseClicked(), modalWidth: 'lg' }), _jsx(VnConfirmationModel, { title: 'Wilt u dit record verwijderen?', onCancel: () => setIsDeleteCalculationConfirmOpen(false), onConfirm: () => onDeleteCalculationClicked(), onOpen: isDeleteCalculationConfirmOpen })] }));
};
export default CalculationTab;
